"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarControlsBlock = exports.ToolbarContainer = exports.ImageModalLegend = exports.ImageModalFieldset = void 0;

var _context = require("../../context");

var _layout = require("../../layout");

var ToolbarControlsBlock = (0, _context.styledWithTheme)(_layout.Row)(function (_ref) {
  var theme = _ref.theme;
  return {
    gap: 8,
    alignItems: 'center',
    borderWidth: 0,
    borderRightWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.selectors.color('neutral20'),
    ':last-of-type': {
      borderRightWidth: 0
    }
  };
});
exports.ToolbarControlsBlock = ToolbarControlsBlock;
var ToolbarContainer = (0, _context.styledWithTheme)(_layout.Row)(function (_ref2) {
  var selectors = _ref2.theme.selectors;
  return {
    width: '100%',
    borderWidth: 0,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderColor: selectors.color('neutral20'),
    overflowX: 'auto',
    flexShrink: 0,
    backgroundColor: selectors.color('neutral0'),
    borderTopLeftRadius: selectors.radius('R300'),
    borderTopRightRadius: selectors.radius('R300')
  };
});
exports.ToolbarContainer = ToolbarContainer;
var ImageModalFieldset = (0, _context.styledWithTheme)('fieldset')({
  border: 'none',
  padding: 0,
  margin: 0
});
exports.ImageModalFieldset = ImageModalFieldset;
var ImageModalLegend = (0, _context.styledWithTheme)('legend')(function (_ref3) {
  var selectors = _ref3.theme.selectors;
  return {
    color: selectors.color('neutral90'),
    display: 'inline'
  };
});
exports.ImageModalLegend = ImageModalLegend;